import { SwiperSlide } from 'swiper/react';
import { Lazy, Navigation } from 'swiper';
import Link from 'next/link';

import { CampaignPromotionItemViewModel } from '@api/index';
import { LandingLink } from '@components/views/landing/common/Header/Header';
import Typography from '@components/Typography';
import Carousel from '@components/views/homepage/components/MostPreferredHotels/Carousel';
import IsInViewPort from '@components/ui/IsInViewPort';
import {
  selectPromotion,
  viewPromotion,
} from '@utils/newDataLayer/promotionEvents';

import CampaignCard from '../CampaignCard/CampaignCard';
import {
  Container,
  HeaderContainer,
  ItemWrapper,
  Wrapper,
  ContentWrapper,
} from './styled';
import { CampaignPromotionsProps } from './CampaignPromotions';

export const CampaignPromotionsDesktop = ({
  data,
  link,
  title = 'Öne Çıkan Kampanyalar',
  text = '',
  showHeader = true,
  imagesKey = 'images',
}: CampaignPromotionsProps) => {
  return (
    <Container>
      <HeaderContainer>
        <Wrapper>
          {showHeader ? (
            <Typography variant='Title3' color='BR300' weight='Black'>
              {title}
            </Typography>
          ) : (
            false
          )}
          {link?.href ? (
            <LandingLink
              containerPosition='flex-end'
              link={link?.href}
              linkText={link?.name}
            />
          ) : null}
        </Wrapper>
      </HeaderContainer>
      <ItemWrapper>
        <Carousel
          loop={false}
          spaceBetween={20}
          preloadImages={false}
          lazy={{
            enabled: true,
          }}
          modules={[Lazy, Navigation]}
        >
          {data?.map((campaign: CampaignPromotionItemViewModel) => (
            <SwiperSlide key={campaign.id}>
              <Link
                href={campaign.url}
                onClick={() => {
                  const index = data.findIndex(
                    (item) => item.id === campaign.id
                  );
                  selectPromotion(
                    'Anasayfa - Öne Çıkan Kampanyalar',
                    index.toString(),
                    campaign.id ?? '',
                    campaign.name
                  );
                }}
                title={campaign.name}
                prefetch={false}
              >
                <IsInViewPort
                  key={campaign.id}
                  onViewVisible={() => {
                    const index = data.findIndex(
                      (item) => item.id === campaign.id
                    );
                    viewPromotion(
                      'Anasayfa - Öne Çıkan Kampanyalar',
                      index.toString(),
                      campaign.id ?? '',
                      campaign.name
                    );
                  }}
                >
                  <CampaignCard
                    id={campaign.id || ''}
                    url={campaign.url}
                    images={campaign[imagesKey]}
                    subTitle={campaign.subText}
                    campaignImages={campaign.icons}
                    name={campaign.name}
                    showPriority={false}
                  />
                </IsInViewPort>
              </Link>
            </SwiperSlide>
          ))}
        </Carousel>
      </ItemWrapper>

      {text ? (
        <ContentWrapper>
          <Typography variant='caption2' color='D100' weight='Regular'>
            {text}
          </Typography>
        </ContentWrapper>
      ) : null}
    </Container>
  );
};
